import { result, transform } from 'lodash';

// lodash result, but for multiple paths in the same object. useful when your APIs data structure is nasty.
export default (item = {}, ...paths) =>
    transform(
        paths,
        (accumulator, currentPath) => {
            const currentResult = result(item, currentPath);
            if (currentResult) {
                accumulator.push(currentResult);
            }
            return !accumulator.length;
        },
        []
    )[0];
